import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/Card";
import VerticalTimelineComponent from "./VerticalTimeLineComponent.jsx";
import { useSelector } from "react-redux";
import { timelineData, isKiosk } from "../features/AppSlice";
import TaxpayerInfoComponent from "./TaxpayerInfoComponent.jsx";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import Tooltip from "@mui/material/Tooltip";

export default function TimelineViewerComponent(props) {
  const timeline = useSelector(timelineData);
  const surveyURL = import.meta.env.REACT_APP_SURVEYLINK;
  const kioskMode = useSelector(isKiosk);
  return (
    <>
      <Grid container item justifyContent={"center"}>
        <TaxpayerInfoComponent />
      </Grid>
      <Card>
        <CardContent>
          <VerticalTimelineComponent timelineData={timeline} />
          <Box
            sx={{
              display: { xs: "block", sm: "block", md: "block", lg: "none" },
            }}
          >
            <Grid
              container
              item
              justifyContent={"center"}
              sx={{ marginBottom: "1%" }}
            >
              {surveyURL !== "" ? (
                <Tooltip title="Satisfaction Survey">
                  <Button
                    color="success"
                    variant="contained"
                    sx={{
                      borderRadius: "10px",
                      verticalAlign: "top",
                      borderColor: "white",
                    }}
                    startIcon={
                      <PollOutlinedIcon aria-label="Key" fontSize="large" />
                    }
                    onClick={() => {
                      window.open(surveyURL, "_self", "noopener,noreferrer");
                    }}
                  >
                    Please take a moment to complete a survey on your
                    interaction
                  </Button>
                </Tooltip>
              ) : null}
            </Grid>
          </Box>
          <Box
            sx={{
              display: { xs: "none", sm: "none", md: "none", lg: "block" },
            }}
          >
            <Grid
              container
              item
              xs={12}
              justifyContent={"center"}
              sx={{ marginBottom: "1%" }}
            >
              {surveyURL !== "" ? (
                <Tooltip title="Satisfaction Survey">
                  <Button
                    variant="contained"
                    color="success"
                    sx={{
                      borderRadius: "10px",
                      verticalAlign: "top",
                      borderColor: "white",
                    }}
                    startIcon={
                      <PollOutlinedIcon aria-label="Key" fontSize="large" />
                    }
                    onClick={() => {
                      if (kioskMode) {
                        window.parent.postMessage({
                          sender: "iframe",
                          type: "Navigate",
                          location: surveyURL + "kiosk",
                        });
                      } else {
                        window.open(
                          surveyURL + "website",
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }
                    }}
                  >
                    Please take a moment to complete a survey on your
                    interaction
                  </Button>
                </Tooltip>
              ) : null}
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
